import { render, staticRenderFns } from "./ServicesInInvoice.vue?vue&type=template&id=16b53168&"
import script from "./ServicesInInvoice.vue?vue&type=script&lang=js&"
export * from "./ServicesInInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports